import React, { useState } from 'react';
import BaseButton from "../BaseButton";
import xIcon from "../../assets/fi_x-circle.svg";
import PageLabel from "../PageLabel";

function ConfirmCancellation({ handleCancellation, setCancellationModalOpen, externalError }) {
    const [selectedReason, setSelectedReason] = useState(null);
    const [customReason, setCustomReason] = useState('');
    const [error, setError] = useState(externalError);

    const reasonOptions = ['Per ilgai laukti', 'Nebereikia'];

    const onCancelSubmit = () => {
        const reason = selectedReason || customReason.trim();

        if (!reason) {
            setError("Pasirinkite arba įrašykite priežastį");
            return;
        }

        setError(null);
        handleCancellation(reason);
    };

    return (
        <>
            <PageLabel text={'Atšaukti kelionę'}/>
            <div className="rideInProgress pageContent">
                <div className="confirmCancellation">
                    <span>Dėl kokios priežasties atšaukiate kelionę?</span>

                    <div className="cancel-reason-buttons">
                        {reasonOptions.map((reason, index) => (
                            <button
                                key={index}
                                type="button"
                                className={`btn-select ${selectedReason === reason ? 'btn-select--active' : ''}`}
                                onClick={() => {
                                    setSelectedReason(prev => (prev === reason ? null : reason));
                                    setError(null);
                                }}
                            >
                                {reason}
                            </button>
                        ))}
                    </div>

                    <textarea
                        className="textarea"
                        name="reason"
                        id="reason"
                        placeholder="Įrašykite priežastį"
                        value={customReason}
                        onChange={(e) => {
                            setCustomReason(e.target.value);
                            if (e.target.value) {
                                setSelectedReason(null);
                                setError(null);
                            }
                        }}
                    />

                    {error && <div className="error-message">{error}</div>}

                    <div className="confirmCancellation__buttons">
                        <BaseButton
                            text="Atgal"
                            handleOnClick={() => {
                                setCancellationModalOpen(false);
                            }}
                            className="baseButton--secondary"
                        />
                        <BaseButton
                            text="Atšaukti"
                            handleOnClick={onCancelSubmit}
                            className="baseButton--secondary-danger"
                            icon={xIcon}
                            iconClassName="iconLeft"
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default ConfirmCancellation;
